import {
  ParameterStructuredTable,
  ParameterStructuredTableMetadata,
  ParameterStructuredTableRowMetadata,
} from 'notebook/integrations/procedures/ParameterStructuredTableAdapter';
import {ParameterStructuredTableModeToTypeName} from 'notebook/integrations/procedures/ParameterStructuredTableConstants';
import {StructuredTableToTableMetadata, Table} from 'notebook/tables/TableConstants';

export const computeIsTableRowTombstoned = (table: Table, rowIndex: number): boolean | undefined =>
  (table.rowData?.[rowIndex]?.rowMetadata as ParameterStructuredTableRowMetadata)?.isTombstoned;

export const computeTombstoneReasonTooltip = (table: Table): string => {
  const tableMetadata = table.metadata as StructuredTableToTableMetadata<ParameterStructuredTable>;
  const tableMode = (tableMetadata?.metadata as unknown as ParameterStructuredTableMetadata)?.mode;
  const typeName = ParameterStructuredTableModeToTypeName[tableMode] || 'row';
  return `Deleted ${typeName}. Please adjust any formulas before deleting row.`;
};

export const computeHasUnsubmittedChanges = (
  table: Table,
  rowIndex: number,
  isConfigTable: boolean
): boolean | undefined =>
  table.rowData?.[rowIndex]?.uiData?.hasUnsubmittedChanges && !isConfigTable ? true : undefined;

export const computeIsRowOutdated = (staleRows: Array<number> | undefined, rowIndex: number): boolean =>
  staleRows != null && staleRows.length > 0 && staleRows.includes(rowIndex);

export const computeTombstoneReasonTooltipForRow = (table: Table, rowIndex: number): string | null => {
  const isTombstoned = computeIsTableRowTombstoned(table, rowIndex);
  if (isTombstoned) {
    return computeTombstoneReasonTooltip(table);
  }
  return null;
};
